import ChartTab from '../../components/ChartTab';

const ChartPage = () => {
  return <ChartTab />;
};

export default ChartPage;